import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { LOCAL_STORAGE_KEY, StorageService } from '@services/storage.service';
import { ROUTE_PATH } from '@shared/enum/common.enum';

export const selectGuard: CanActivateFn = () => {
    const storageService = inject(StorageService);
    const router = inject(Router);

    if (storageService.getItem(LOCAL_STORAGE_KEY.SELECT_ROLE) === 'true') {
        return true;
    } else {
        router.navigate([ROUTE_PATH.DASHBOARD]);
        return false;
    }
};
